// ---------------------------------------------- modules import
import moment from "moment";
import React, { FunctionComponent, useEffect } from "react";
import { Link } from "react-router-dom";

import { ISummaryProps } from "./common";
import { useAuth } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper from "../../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const Summary: FunctionComponent<ISummaryProps> = ({
  album,
  menuIndex,
  onDelete
}) => {
  const { id, name, creator, link, lastModified } = album;

  // ---------------------------------------------- local state
  const { auth, profile } = useAuth();

  // ---------------------------------------------- handlers
  const handleDelete = () => onDelete(auth, id);

  // ---------------------------------------------- effects
  useEffect(() => {
    const modals = document.querySelectorAll(".modal");

    M.Modal.init(modals);
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="card col s12 m5 offset-m1" style={{ padding: "0px" }}>
          <div
            className="card-content grey-text text-darken-3"
            style={{ paddingBottom: "0px" }}
          >
            <span style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
              {name}
            </span>

            <div style={{ marginBottom: "8px" }}>
              <p style={{ fontSize: "0.75rem" }}>
                last modified {moment(lastModified.toDate()).calendar()}
              </p>

              <p className="grey-text" style={{ fontSize: "0.65rem" }}>
                created by {creator.name} | {creator.email}
              </p>
            </div>
          </div>

          <div
            className="card-action right-align"
            style={{ marginBottom: "0" }}
          >
            <a
              className="btn-floating btn-small waves-effect waves-light"
              href={link}
              style={{ backgroundColor: theme.ui, margin: "0 5px" }}
            >
              <i className="material-icons">zoom_in</i>
            </a>

            {PermissionHelper.getModify(profile.permissions, menuIndex) ? (
              <>
                <Link
                  to={`/${PermissionHelper.getUrl(menuIndex)}/update/${id}`}
                  className="btn-floating btn-small waves-effect waves-light"
                  style={{ backgroundColor: theme.ui, margin: "0 5px" }}
                >
                  <i className="tiny material-icons">edit</i>
                </Link>

                <button
                  type="button"
                  className="btn-floating btn-small waves-effect waves-light modal-trigger"
                  data-target={`alert-${id}`}
                  style={{ backgroundColor: theme.ui, marginLeft: "5px" }}
                >
                  <i className="tiny material-icons">delete</i>
                </button>

                <div className="modal" id={`alert-${id}`}>
                  <div className="modal-content center">
                    <h5>Confirm Delete</h5>

                    <p>{`Are you sure you want to delete this album?`}</p>
                  </div>

                  <div className="modal-footer">
                    <div className="container">
                      <button
                        type="button"
                        className="btn modal-close"
                        style={{ backgroundColor: theme.ui }}
                        onClick={handleDelete}
                      >
                        Yes, I'm sure
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default Summary;
